import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

interface Site {
  id: string
  domain: string
  verified: boolean
  businessType: string
}

export function DashboardPage() {
  const t = useT()
  const sites = useQuery({
    queryKey: ['sites'],
    queryFn: () => apiClient.get<{ data: Site[] }>('/sites'),
  })

  if (sites.isLoading) return <p>{t('common.loading')}</p>
  if (sites.isError) return <p>{t('common.error')}</p>

  const data = sites.data?.data ?? []
  if (data.length === 0) {
    return (
      <div className="max-w-md">
        <h1 className="text-2xl font-semibold mb-1">{t('dashboard.empty.title')}</h1>
        <p className="opacity-70 mb-4">{t('dashboard.empty.body')}</p>
        <Link
          to="/onboard"
          className="inline-block px-4 py-2 rounded text-sm font-medium"
          style={{ background: 'var(--color-accent)', color: 'white' }}
        >
          {t('dashboard.empty.cta')}
        </Link>
      </div>
    )
  }

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">{t('dashboard.title')}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {data.map((s) => (
          <Link key={s.id} to={`/sites/${s.id}`} className="block p-4 rounded border" style={{ borderColor: 'var(--color-border)' }}>
            <div className="font-medium">{s.domain}</div>
            <div className="text-xs opacity-60 mt-1">{s.businessType}</div>
            <div className="text-xs mt-2">{s.verified ? '✓ verified' : 'pending verification'}</div>
          </Link>
        ))}
      </div>
    </div>
  )
}
